/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from "react";
import CommonModule from "../CommonModule";
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid, Link, styled, Switch, Tooltip, Typography } from "@mui/material";
import { BudgetType, CurrencyJSON, DepartmentType, getProjectSize } from "../../../../common/const";
import { LoadingPage } from "../../../../common/LoadingPage";
import { ArrowBack, DeleteOutline, EditOutlined } from "@mui/icons-material";
import CreateModule from "../CreateModule";
import { apiRequest } from "../../../../common/common";
import moment from "moment";
import FilterPanel from "./FilterPanel";
import { RoomColDefs } from "../columnDefs";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import ColumnHeader from "../../Catalog/columnHeader";
import { useSelector } from "react-redux";
import ColumnPanel from "../../../../common/ColumnPanel";
import * as XLSX from 'xlsx';

const DemoTypo = styled(Typography)(({ theme }) => ({
    fontSize: 14
}));

const DemoTypo1 = styled(Typography)(({ theme }) => ({
    fontSize: 14,
    fontWeight: 'bold'
}));

const FixedBox = styled(Box)(({ theme }) => ({
    width: '110px'
}));

const RoomModule = ({
    projectId,
    department,
    projectData,
    setActiveTab,
    setRoom,
}) => {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [rowsPerPage, setRowPerPage] = useState(localStorage.getItem('roomPageSize') || 10);
    const [searchingText, setSearchText] = useState(null || localStorage.getItem('search'));
    const [gridApi, setGridApi] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [notes, setNotes] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [roomId, setRoomId] = useState(null);
    const [roomData, setRoomData] = useState(null);
    const [isChecked, setIsChecked] = useState(false);
    const [indeterminate, setIndeterminate] = useState(false);
    const [returnedData, setReturnedData] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [roomColumn, setRoomColumn] = useState(RoomColDefs);
    const [settingData, setSettingData] = useState([]);
    const [countData, setCountData] = useState({});

    const onGridReady = useCallback((params) => {
        if (params?.api) {
            const { api, searchingText, filters } = params;
            if (filters) {
                localStorage.setItem('roomfilters', JSON.stringify(filters));
            }
            const filter = localStorage.getItem('roomfilters') ? JSON.parse(localStorage.getItem('roomfilters')) : filters;
            setGridApi(api);
            setDataLoading(true);
            const dataSource = {
                rowCount: null,
                getRows: async (params) => {
                    const sortModel = params?.sortModel[0];
                    const sortBy = {
                        column: sortModel?.colId === 'inactive_item_qty' ? 'item_quantity' : sortModel?.colId === 'department' ? 'department_name' : sortModel?.colId || 'room_name',
                        order: sortModel?.sort || 'asc',
                    };
                    setActivePage(Math.floor((params.startRow / rowsPerPage) + 1));
                    if (projectId) {
                        const url = [
                            `/project-room?projectId=${projectId}`,
                            department?.department_id ? `&departmentIds=${department?.department_id}` : '',
                            `pageNo=${Math.floor((params.startRow / rowsPerPage) + 1)}`,
                            `pageSize=${rowsPerPage}`,
                            filter?.building?.length > 0 ? `buildingIds=${filter?.building}` : '',
                            filter?.level?.length > 0 ? `levelIds=${filter?.level}` : '',
                            filter?.department?.length > 0 ? `departmentIds=${filter?.department}` : '',
                            filter?.budgetids?.length > 0 ? `budgetIds=${filter?.budgetids}` : '',
                            filter?.costCentre?.length > 0 ? `costCentreIds=${filter?.costCentre}` : '',
                            filter?.areaPhase?.length > 0 ? `phaseIds=${filter?.areaPhase}` : '',
                            filter?.isDeleted === 'yes' || filter?.isDeleted === 'no' ? `isDeleted=${filter?.isDeleted === 'yes' ? true : ''}` : `isDeleted=${department?.is_deleted ? true : ''}`,
                            filter?.isNotes === 'yes' || filter?.isNotes === 'no' ? `isNotes=${filter?.isNotes}` : '',
                            sortBy?.column ? `sortBy=${sortBy.column}` : '',
                            sortBy?.order ? `sortOrder=${sortBy.order}` : '',
                            searchingText || localStorage.getItem('search') ? `searchText=${encodeURIComponent(searchingText || localStorage.getItem('search'))}` : ''
                        ].filter(Boolean).join('&');
                        try {
                            const response = await apiRequest('get', `${url}`);
                            const { data, total_count, total_quantity, total_room_area, total_cost } = response.data;
                            let lastRow = -1;
                            if (data?.length <= total_count) {
                                lastRow = total_count;
                            }
                            setReturnedData(data);
                            setCountData({
                                total_area: total_room_area,
                                total_quantity,
                                total_cost
                            });
                            setSelectedData([]);
                            setIsChecked(false);
                            params.successCallback(data, lastRow);
                            setDataLoading(false);
                        } catch (error) {
                            setDataLoading(false);
                            showNotification(error?.response?.data.error || error.message, 'error');
                        }
                    }
                },
            };
            api.setGridOption("datasource", dataSource);
            setTimeout(() => {
                const node = api.getRenderedNodes();
                if (!node?.[0]?.displayed) {
                    api.showNoRowsOverlay();
                }
            }, 5000);
        }
    }, [rowsPerPage, projectId, department?.department_id]);

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            onGridReady({
                api: gridApi,
            });
        }
        return () => {
            isMounted = false;
        };
    }, [rowsPerPage, projectId, department?.department_id]);

    useEffect(() => {
        if (roomColumn?.length > 0 && gridApi) {
            const columnState = gridApi?.getColumnState()?.map(state => {
                const columnConfig = roomColumn.find((c) => c.colId === state.colId || c.field === state.colId);
                if (columnConfig) {
                    if (columnConfig.pinned !== state.pinned) {
                        state.pinned = columnConfig.pinned ? columnConfig.pinned : null;
                    }
                }

                return state;
            });
            gridApi?.applyColumnState({ state: columnState });
            gridApi?.refreshHeader();
        }
    }, [roomColumn]);

    const getData = async () => {
        try {
            setDataLoading(true)
            const response = await apiRequest('get', `/user-view?userId=${user?.user_id}&type=project-room&pageNo=1&pageSize=50`);
            const { data } = response.data;
            if (data?.length > 0) {
                if (data?.find((a) => a.is_pinned === true)?.columns) {
                    setRoomColumn([...roomColumn.slice(0, 3), ...data?.find((a) => a.is_pinned === true)?.columns]);
                }
                setSettingData(data);
            } else {
                setSettingData([]);
            }
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if (user?.user_id) {
            getData();
        }
    }, [user?.user_id]);

    const handleExportExcel = async () => {
        try {
            setDataLoading(true);
            const url = [
                `/project-room?projectId=${projectId}`,
                department?.department_id ? `departmentIds=${department.department_id}` : '',
                `pageNo=1`, `pageSize=10000`, `sortBy=room_name`, `sortOrder=asc`,
            ].filter(Boolean).join('&');
            const response = await apiRequest('get', url);
            const { data } = response.data;
            const currencySymbol = CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol ?? '';
            const exportRows = (data || []).map((row) => ({
                'Room No':       row.room_no ?? '--',
                'Room Name':     row.room_name ?? '--',
                'Room Signage':  row.room_signage ?? '--',
                'Tags':          row.tags ?? '--',
                'Building':      row.building?.building_name ?? '--',
                'Level':         row.level?.level_name ?? '--',
                'Department':    row.department?.department_name ?? '--',
                'Status':        row.is_deleted === false ? 'Active' : 'InActive',
                'Quantity':      row.quantity ?? 0,
                'Active Items':  row.total_item ?? 0,
                'Extended Qty':  (row.total_item || 0) * (row.quantity || 0),
                'Inactive Items': row.inactive_item_quantity ?? 0,
                'Room Area':     row.room_area != null ? getProjectSize(projectData?.default_project_units, row.room_area) : '--',
                'Total Area':    row.room_area != null ? getProjectSize(projectData?.default_project_units, row.room_area * (row.quantity || 0)) : '--',
                'Phase':         row.phase?.phase_name ?? '--',
                'Phase Date':    row.phase_date ? moment(row.phase_date).format('DD-MM-YYYY') : '--',
                'Need By':       row.need_by ? moment(row.need_by).format('DD-MM-YYYY') : '--',
                'Budget Name':   row.budget?.budget_name ?? '--',
                'Budget No':     row.budget?.budget_no ?? '--',
                'Budget Type':   BudgetType.find((a) => a.value === row.budget?.type)?.name ?? '--',
                'Expense Code':  row.budget?.expanse_code ?? '--',
                'Cost Centre':   row.cost_centre?.cost_centre_name ?? '--',
                'Sub Total':     `${currencySymbol} ${Intl.NumberFormat('en-IN').format(row.sub_total || 0)}`,
                'Room Total':    `${currencySymbol} ${Intl.NumberFormat('en-IN').format(row.room_total || 0)}`,
                'Extended Cost': `${currencySymbol} ${Intl.NumberFormat('en-IN').format((row.quantity || 0) * (row.room_total || 0))}`,
                'Notes':         row.notes ?? '--',
            }));
            const ws = XLSX.utils.json_to_sheet(exportRows);
            ws['!cols'] = Object.keys(exportRows[0] || {}).map((key) => ({
                wch: Math.max(key.length, ...exportRows.map((r) => String(r[key] ?? '').length)) + 2,
            }));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Rooms');
            XLSX.writeFile(wb, `Rooms_${projectId}.xlsx`);
        } catch (error) {
            showNotification(error?.response?.data?.error || error.message, 'error');
        } finally {
            setDataLoading(false);
        }
    };

    const toolPanel = useMemo(() => [
        {
            id: 'custom1',
            labelDefault: 'Columns',
            iconKey: "columns",
            toolPanel: ColumnPanel,
            width: 450,
            toolPanelParams: {
                columns: roomColumn?.slice(3, 29),
                setColumns: (column) => {
                    setRoomColumn([...roomColumn.slice(0, 3), ...column]);
                },
                settingData,
                fetchData: () => {
                    if (user?.user_id) {
                        getData();
                    }
                },
                type: "project-room",
                defaultVisibleColumns: RoomColDefs?.slice(3, 29),
                columnOrder: roomColumn?.slice(3, 29)
            }
        },
        {
            id: 'custom2',
            iconKey: "filter",
            labelDefault: 'Filters',
            toolPanel: FilterPanel,
            width: 300,
            toolPanelParams: {
                projectId,
                applyFilter: (filters) => {
                    setRowPerPage(localStorage.getItem('roomPageSize') || 10);
                    onGridReady({
                        api: gridApi,
                        filters
                    });
                }
            }
        }
    ], [gridApi, settingData, projectId, roomColumn]);

    const onSelectChanged = (value) => {
        if (gridApi) {
            if (value === 1) {
                const selectedNodes = gridApi.getSelectedNodes();
                gridApi?.forEachNode((node) => {
                    selectedNodes.push(node);
                    node.setSelected(true);
                });
                const uniqueNodesSet = new Set(selectedNodes);
                const uniqueNodesArray = Array.from(uniqueNodesSet);
                const data = uniqueNodesArray?.map((node) => node.data);
                setSelectedData(data);
            } else if (value === 2) {
                const selectedNodes = gridApi.getSelectedNodes();
                selectedNodes?.forEach((node) => node.setSelected(false));
            }
        }
    };

    const removeAllColumn = () => {
        if (gridApi) {
            setSelectedData([]);
            setIsChecked(false);
            setIndeterminate(false);
            const selectedNodes = gridApi.getSelectedNodes();
            selectedNodes.forEach((node) => node.setSelected(false));
        }
    };

    const updatedColumns = useMemo(() => {
        let column = roomColumn;
        if (column.length > 0) {
            return column?.map((col) => {
                switch (col.field) {
                    case '':
                        return {
                            ...col,
                            hide: isUser?.code === 'orgGuestUser',
                            headerComponent: ColumnHeader,
                            headerComponentParams: {
                                onSelectChanged,
                                removeAllColumn,
                                isChecked,
                                setIsChecked,
                                indeterminate,
                                setIndeterminate,
                            },
                        };
                    case 'action':
                        return {
                            ...col,
                            hide: isUser?.code === 'orgGuestUser',
                            cellRenderer: (params) => params?.data && (
                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                    {!params?.data?.is_deleted && (
                                        <Tooltip title="Edit Room">
                                            <EditOutlined
                                                color="primary"
                                                style={{ cursor: 'pointer', color: selectedData?.length === 1 && selectedData?.find((a) => a.room_id === params?.data?.room_id) ? '' : 'gray' }}
                                                onClick={() => {
                                                    if (selectedData?.length === 1 && selectedData?.find((a) => a.room_id === params?.data?.room_id)) {
                                                        setOpen(true);
                                                        setRoomId(params?.data.room_id);
                                                    }
                                                }}
                                            />
                                        </Tooltip>
                                    )}
                                    <Tooltip title={params?.data?.is_deleted === false ? 'Active' : 'InActive'}>
                                        <Switch
                                            size="small"
                                            disabled={!selectedData?.find((a) => a.room_id === params?.data?.room_id)}
                                            checked={params?.data?.is_deleted === false}
                                            onChange={async (e) => {
                                                setDataLoading(true);
                                                try {
                                                    const response = await apiRequest('patch', `/project-room/set-delete-status/${selectedData?.map((a) => a.room_id)?.toString()}`, {
                                                        isDeleted: e.target.checked === true ? false : true
                                                    });
                                                    if (response?.data) {
                                                        onGridReady({
                                                            api: gridApi
                                                        })
                                                        setDataLoading(false);
                                                        showNotification(response?.data?.message, 'success');
                                                    }
                                                } catch (error) {
                                                    setDataLoading(false);
                                                    showNotification(error?.response?.data.error || error.message, 'error');
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                    <Tooltip title="Permanent Delete">
                                        <DeleteOutline
                                            color="secondary"
                                            style={{ cursor: 'pointer', color: selectedData?.find((a) => a.room_id === params?.data?.room_id) ? '' : 'gray' }}
                                            onClick={() => {
                                                if (selectedData?.find((a) => a.room_id === params?.data?.room_id)) {
                                                    setDeleteOpen(true);
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                </Box>
                            ),
                        }
                    case 'quantity':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => (
                                <Box
                                    style={{ display: 'flex', gap: 5, cursor: params?.data?.quantity > 1 ? 'pointer' : null }}
                                    onClick={async () => {
                                        if (!params?.data?.is_deleted && params?.data?.quantity > 1) {
                                            let dataArr = [];
                                            for (let i = 1; i <= params?.data?.quantity; i++) {
                                                const data = {
                                                    room_name: `${params?.data?.room_name} (${i} of ${params?.data?.quantity})`,
                                                    quantity: 1
                                                }
                                                dataArr.push(data);
                                            }
                                            setDataLoading(true);
                                            try {
                                                const response1 = await apiRequest('put', `/project-room/${params?.data?.room_id}`, dataArr[0]);
                                                const response2 = await apiRequest('post', '/project-room/multiple-create', {
                                                    room_id: params?.data?.room_id,
                                                    room_data: dataArr.slice(1, dataArr.length),
                                                    status: 'active',
                                                    organization_id: user?.organization?.organization_id,
                                                    building_id: params?.data?.building_id,
                                                    level_id: params?.data?.level_id,
                                                    department_id: params?.data?.department_id
                                                });
                                                if (response1?.data && response2?.data) {
                                                    setDataLoading(false);
                                                    onGridReady({
                                                        api: gridApi
                                                    });
                                                    showNotification('Room exploded successfullly', 'success');
                                                }
                                            } catch (error) {
                                                setDataLoading(false);
                                                showNotification(error?.response?.data.error || error.message, 'error');
                                            }
                                        }
                                    }}
                                >
                                    <Box style={{ width: '20px' }}>
                                        {(!params?.data?.is_deleted && params?.data?.quantity > 1) && (
                                            <img src="/images/explode.svg"
                                                alt="img"
                                                style={{ marginTop: '2px' }}
                                            />
                                        )}
                                    </Box>
                                    {params?.data?.quantity}
                                </Box>
                            )
                        }
                    case 'room_name':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 175,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => {
                                if (params?.data && !params?.data.is_deleted) {
                                    return (
                                        <Link
                                            style={{ textDecoration: 'none', cursor: 'pointer' }}
                                            onClick={() => {
                                                setActiveTab('Items');
                                                setRoom(params?.data);
                                            }}
                                        >

                                            {params?.data?.room_name || '--'}
                                        </Link>
                                    )
                                } else {
                                    return (
                                        <span
                                            style={{ color: 'red', cursor: 'pointer' }}
                                            onClick={() => {
                                                setActiveTab('Items');
                                                setRoom(params?.data);
                                            }}
                                        >{params?.data?.room_name || '--'}</span>
                                    )
                                }
                            },
                        }
                    case 'subtotal':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.sub_total || 0)}`}
                                </>
                            ),
                        }
                    case 'status':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {!params?.data?.is_deleted ? 'Active' : 'InActive'}
                                </>
                            ),
                        }
                    case 'building':
                        return {
                            ...col,
                            minWidth: 120,
                            flex: 1,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.building?.building_name || '--'}
                                </>
                            ),
                        }
                    case 'level':
                        return {
                            ...col,
                            minWidth: 150,
                            flex: 1,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.level?.level_name || '--'}
                                </>
                            ),
                        }
                    case 'department':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 220,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.department?.department_name || '--'}
                                </>
                            ),
                        }
                    case 'item_quantity':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 80,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.total_item || '0'}
                                </>
                            ),
                        }
                    case 'extended_qty':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 125,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.total_item * params?.data?.quantity || '0'}
                                </>
                            ),
                        }
                    case 'inactive_item_qty':
                        return {
                            ...col,
                            minWidth: 90,
                            flex: 1,
                            sortable: false,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.inactive_item_quantity || '0'}
                                </>
                            ),
                        }
                    case 'room_total':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 150,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.room_total || 0)}`}
                                </>
                            ),
                        }
                    case 'extended_cost':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 150,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format((params?.data?.quantity * params?.data?.room_total) || 0)}`}
                                </>
                            ),
                        }
                    case 'room_area':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.room_area !== null ? getProjectSize(projectData?.default_project_units, params?.data?.room_area) : '--'}
                                </>
                            ),
                        }
                    case 'total_area':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.room_area !== null ? getProjectSize(projectData?.default_project_units, (params?.data?.room_area * params?.data?.quantity)) : '--'}
                                </>
                            ),
                        }
                    case 'need_by':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.need_by ? moment(params?.data?.need_by).format('DD-MM-YYYY') : '--'}
                                </>
                            ),
                        }
                    case 'phase_name':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.phase?.phase_name || '--'}
                                </>
                            ),
                        }
                    case 'budget_name':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.budget?.budget_name || '--'}
                                </>
                            ),
                        }
                    case 'budget_type':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {BudgetType.find((a) => a.value === params?.data?.budget?.type)?.name || '--'}
                                </>
                            ),
                        }
                    case 'budget_no':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.budget?.budget_no || '--'}
                                </>
                            ),
                        }
                    case 'expanse_code':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.budget?.expanse_code || '--'}
                                </>
                            ),
                        }
                    case 'cost_centre_name':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.cost_centre?.cost_centre_name || '--'}
                                </>
                            ),
                        }
                    case 'room_no':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data?.room_no ? (
                                <span>{params?.data?.room_no}</span>
                            ) : '--'
                        }
                    case 'tags':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data?.tags ? (
                                <span>{params?.data?.tags}</span>
                            ) : '--'
                        }
                    case 'room_signage':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data?.room_signage ? (
                                <span>{params?.data?.room_signage}</span>
                            ) : '--'
                        }
                    case 'phase_date':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.phase_date ? moment(params?.data?.phase_date).format('DD-MM-YYYY') : '--'}
                                </>
                            ),
                        }
                    case 'notes':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 110,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data?.notes ? (
                                <Link
                                    style={{ textDecoration: 'none', cursor: 'pointer' }}
                                    onClick={() => {
                                        setNotes(params?.data.notes);
                                    }}
                                >
                                    View Notes
                                </Link>
                            ) : '--',
                        }
                    default:
                        return col;
                }
            });
        }
        return column;
    }, [roomColumn, selectedData, isChecked, indeterminate]);

    const getRoomData = async () => {
        const url = [
            `/project-room/${roomId}`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setRoomData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if (roomId !== null) {
            getRoomData();
        }
    }, [roomId]);

    return (
        <>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <Grid container>
                <Dialog open={deleteOpen} fullWidth maxWidth="xs">
                    <DialogContent>Are you sure you want to permanently delete this one? It cannot be recovered.</DialogContent>
                    <DialogActions>
                        <Button size="small" variant="contained" color="secondary"
                            onClick={() => {
                                setSelectedData([]);
                                setDeleteOpen(false);
                            }}
                        >
                            No
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                                try {
                                    setDataLoading(true);
                                    let response = await apiRequest('delete', `/project-room/${selectedData?.map((a) => a.room_id)?.toString()}`);
                                    if (response?.data) {
                                        setDataLoading(false);
                                        showNotification(response?.data?.message, 'success');
                                        setSelectedData([]);
                                        setDeleteOpen(false);
                                        onGridReady({
                                            api: gridApi
                                        });
                                    }
                                } catch (error) {
                                    setDataLoading(false);
                                    showNotification(error?.response?.data.error || error.message, 'error');
                                }
                            }}
                        >
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                {open && (
                    <CreateModule
                        open={open}
                        setOpen={setOpen}
                        getData={() => onGridReady({
                            api: gridApi
                        })}
                        innerLabel="Room"
                        projectData={projectData}
                        projectId={projectId}
                        initialData={roomData}
                        setRoomId={setRoomId}
                    />
                )}
                <Grid item xs={12} sm={12} md={(department || notes !== null) ? 10 : 12} style={{ padding: '0px 8px 0px 8px' }}>
                    <CommonModule
                        label="Rooms"
                        innerLabel="Room"
                        columnDefs={updatedColumns}
                        onGridReady={onGridReady}
                        rowsPerPage={rowsPerPage}
                        setRowPerPage={setRowPerPage}
                        searchingText={searchingText}
                        setSearchText={setSearchText}
                        toolPanel={toolPanel}
                        projectId={projectId}
                        gridApi={gridApi}
                        department={department}
                        onSelectionChanged={() => {
                            if (gridApi) {
                                const selectedNodes = gridApi.getSelectedNodes();
                                if (selectedNodes?.length < returnedData?.length * activePage) {
                                    setIsChecked(false);
                                    if (selectedNodes?.length === 0) {
                                        setIndeterminate(false);
                                    } else {
                                        setIndeterminate(true);
                                    }
                                } else {
                                    setIsChecked(true);
                                    setIndeterminate(false);
                                }
                                setSelectedData(selectedNodes?.map((node) => node.data));
                            }
                        }}
                        projectData={projectData}
                        selectionType="multiple"
                        selectedData={selectedData}
                        countData={countData}
                        setSelectedData={setSelectedData}
                        setColumns={setRoomColumn}
                        onExport={handleExportExcel}
                    />
                </Grid>
                {notes !== null && (
                    <Grid item xs={12} sm={12} md={2} style={{ borderLeft: '1px solid lightgray' }}>
                        <Box mt={1} mb={1} ml={1}>
                            <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }} mb={1}>
                                <ArrowBack style={{ cursor: 'pointer', fontSize: 20 }} onClick={() => {
                                    setNotes(null);
                                }} />
                                <DemoTypo1 variant="body2">Notes:</DemoTypo1>
                            </Box>
                            <Divider />
                            <Box style={{ height: '57vh', overflow: 'auto' }} mt={1}>
                                <DemoTypo variant="body2">{notes}</DemoTypo>
                            </Box>
                        </Box>
                    </Grid>
                )}
                {department !== null && (
                    <Grid item xs={12} sm={12} md={2} style={{ borderLeft: '1px solid lightgray' }}>
                        <Box mt={1} mb={1} ml={1}>
                            <Box mt={1} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Department Name:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2">{department?.department_name}</DemoTypo>
                            </Box>
                            <Box mt={1} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Department ID:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2">{department?.department_no || '--'}</DemoTypo>
                            </Box>
                            <Box mt={1} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Department Type:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2" sx={{ ml: { lg: 3 } }}>{DepartmentType.find((a) => a.value === department?.type)?.name || '--'}</DemoTypo>
                            </Box>
                            <Box mt={1} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Level Name:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2">{department?.level?.level_name}</DemoTypo>
                            </Box>
                            <Box mt={1} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Building Name:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2">{department?.building?.building_name}</DemoTypo>
                            </Box>
                            <Box mt={1} style={{ display: 'flex', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Department Notes:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2">{department?.notes || '--'}</DemoTypo>
                            </Box>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </>
    )
}

export default RoomModule;